// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"be6e6f8b","224":"6fccd774"}[chunkId] + ".chunk.css";
};